import { LocalModule } from '../../interfaces/LocalModule';
import { Remote } from '../../interfaces/Remote';

export const remotes: Remote[] = [
  {
    name: 'module_dev_tools',
    imports: ['./ModuleConfiguration'],
    source: '/remotes/module-dev-tools/remoteEntry.js',
  },
];

export const modules: LocalModule[] = [];
